import {useMediaQuery} from '@chakra-ui/react';
import {unwrapResult} from '@reduxjs/toolkit';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {requestOK} from 'redux-thunk-kit';
import {Col, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {MultipleChipSelect} from '~/components/shared/MultipleChipSelect';
import {PAGE_URLS, QUERY_MOBILE} from '~/constants';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {useInput, useRequestState} from '~/hooks';
import {setMedicalUUID, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {redirectInIframe} from '~/utils/helpers';

interface Props {}

const QuestionnaireCGMAddonScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;

  const [redirectLoading, setRedirectLoading] = useState(false);
  const {loading} = useRequestState(submitOrLogMdq);

  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.CGM_ADD_ON_SELECTION);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.CGM_ADD_ON_SELECTION]?.data,
  );

  const collectedData = mdq.collectedData;

  const selectOptions = questionnaire?.options || [];

  const defaultOptions = selectOptions.reduce<Record<string, boolean>>((res, cur) => {
    res[cur.value] = false;

    if (currentAnswer?.selectedOptions?.length) {
      currentAnswer?.selectedOptions.map((i: string) => {
        res[i] = true;
      });
    }

    return res;
  }, {});

  const {inputs, setInputs, validation} = useInput({
    defaultOptions,
  });

  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({
      defaultOptions: {...inputs.defaultOptions, [value]: !inputs.defaultOptions[value]},
    });
  };

  const dataSubmit = Object.keys(inputs.defaultOptions).filter(i => inputs.defaultOptions[i]);

  const onClickSubmit = async () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.CGM_ADD_ON_SELECTION,
      index: questionnaire?.index || '',
      data: {
        selectedOptions: dataSubmit,
      },
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    // dispatch(
    //   submitOrLogMdq({
    //     data: {
    //       uid: medicalUUID,
    //       methodKey: methodKey.toLowerCase(),
    //       status: 'draft',
    //       data: {
    //         ...collectedData,
    //         [WEIGHT_LOSS_KEYS.CGM_ADD_ON_SELECTION]: answerData,
    //       },
    //     },
    //   }),
    // );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.ELEVATE_PROGRAM_GOALS}));
    // history.push(PAGE_URLS.MDQ1_USER_DETAILS);

    const res = await dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'submitted',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.CGM_ADD_ON_SELECTION]: answerData,
          },
        },
      }),
    );

    if (requestOK(res, submitOrLogMdq)) {
      const result = unwrapResult(res);
      if (result.getCheckoutUrl) {
        setRedirectLoading(true);
        redirectInIframe(result.getCheckoutUrl);
      }
    }

    if (res.payload?.errMsg === 'Medical Form invalid') {
      dispatch(setMedicalUUID({uid: null}));
      history.replace(PAGE_URLS.MDQ1_HOME);
    }
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
      disableNext={!dataSubmit.length || redirectLoading || loading}
      loading={redirectLoading || loading}
    >
      <Col alignItems="center" textAlign="center" mt={12} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={7}>
          {questionnaire?.questions?.default}
        </UiText>
        <Col justifyContent="space-between" pb={10} minH={{base: '68vh', md: '60vh', '2xl': '65vh'}}>
          <MultipleChipSelect
            pl={1}
            selectOptions={selectOptions}
            selectedOptions={inputs.defaultOptions}
            onClickOption={onClickOption}
            itemSpacing={5}
          />
          <UiText fontSize="sm">{questionnaire?.questions?.description}</UiText>
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default QuestionnaireCGMAddonScreen;
